import { createRouter, createWebHistory } from "vue-router";
import firebase from "@/firebase";
import auth from "@/services/auth";

import Home from "@/views/Home.vue";
import PostDetail from "@/views/design/PostDetail.vue";
import Login from "@/views/Login.vue";
import PasswordReset from "@/views/PasswordReset.vue";
import NotFound from "@/views/NotFound.vue";

import AdminDashboard from "@/views/admin/AdminDashboard.vue";
import AdminJobDetail from "@/views/admin/AdminJobDetail.vue";
import AdminSites from "@/views/admin/AdminSites.vue";
import AdminSitesDetail from "@/views/admin/AdminSitesDetail.vue";
import AdminSuggestedSites from "@/views/admin/AdminSuggestedSites.vue";
import AdminCreateSite from "@/views/admin/AdminCreateSite.vue";

import BlogMainPageDesign from "@/blog/BlogMainPage";
import DashboardDesign from "@/views/design/Dashboard";
import HelpDesign from "@/views/design/Help";
import HowItWorksDesign from "@/views/design/HowItWorks";
import LoginDesign from "@/views/design/Login";
import PostDetailDesign from "@/views/design/PostDetail";
import PricingDesign from "@/views/design/Pricing";
import SignUpDesign from "@/views/design/SignUp";
import PostJobDesign from "@/views/design/PostJob";
import SuggestSiteDesign from "@/views/design/SuggestSite";
import SuggestSiteThankYouDesign from "@/views/design/SuggestSiteThankYou";
import PrivacyDesign from "@/views/design/Privacy";
import InvoicesView from "@/views/design/Invoices";

import blogRoutes from "@/blog/blog";

import OurJobsLeadRecruiter from "@/views/ourJobs/LeadRecruiter";
import OurJobs from "@/views/ourJobs/OurJobs";

import Sites from "@/views/sites/Sites";
import SiteDetail from "@/views/sites/SiteDetail";

const routes = [
  {
    path: "/sites",
    component: Sites,
    meta: { requiresAuth: false },
  },
  {
    path: "/sites/:slug",
    component: Sites,
    meta: { requiresAuth: false },
  },
  {
    path: "/site/:id",
    component: SiteDetail,
    meta: { requiresAuth: false },
  },
  {
    path: "/our-jobs",
    component: OurJobs,
    meta: { requireAuth: false },
  },
  {
    path: "/our-jobs/lead-recruiter",
    component: OurJobsLeadRecruiter,
    meta: { requireAuth: false },
  },
  {
    path: "/privacy",
    component: PrivacyDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/blog",
    component: BlogMainPageDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/blog-:category",
    component: BlogMainPageDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/help",
    component: HelpDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/how-it-works",
    component: HowItWorksDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/login",
    component: LoginDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/post-detail",
    component: PostDetailDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/sign-up",
    component: SignUpDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/post-job",
    component: PostJobDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/suggest-site",
    component: SuggestSiteDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/suggest-site-thank-you",
    component: SuggestSiteThankYouDesign,
    meta: { requireAuth: false },
  },
  {
    path: "/dashboard",
    component: DashboardDesign,
    meta: { requireAuth: true },
  },
  {
    path: "/invoices",
    component: InvoicesView,
    meta: { requireAuth: true },
  },
  {
    path: "/",
    component: Home,
    meta: { requiresAuth: false },
  },
  {
    path: "/job-offer/:id",
    component: PostDetail,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/password-reset",
    component: PasswordReset,
    meta: { requiresAuth: false },
  },
  {
    path: "/pricing",
    component: PricingDesign,
    meta: { requireAuth: false },
  },
  /*
  {
    path: '/site-detail/:id',
    component: SiteDetail,
    meta: { requiresAuth: false, },
    props: true,
  },
*/
  {
    path: "/admin",
    component: AdminDashboard,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admin-suggested-sites",
    component: AdminSuggestedSites,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admin-job-detail/:id",
    component: AdminJobDetail,
    meta: { requiresAuth: true, requiresAdmin: true },
    props: true,
  },
  {
    path: "/admin-sites",
    component: AdminSites,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admin-sites-detail",
    component: AdminSitesDetail,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/admin-create-site",
    component: AdminCreateSite,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const r = routes.concat(blogRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes: r,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
  const requiresAdmin = to.matched.some((x) => x.meta.requiresAdmin);
  const requiresNoAuth = to.matched.some((x) => x.meta.requiresNoAuth);

  await firebase.waitFirstAuth();

  if (requiresNoAuth && firebase.auth.currentUser != null) {
    next(requiresNoAuth);
    return;
  }

  const isAdmin = await auth.fetchUserIsAdmin();
  if (requiresAdmin) {
    if (!isAdmin) {
      next("/login");
      return;
    }
  }

  if (requiresAuth && firebase.auth.currentUser == null) {
    next("/login");
    return;
  }

  if (firebase.auth.currentUser != null && to.path === "/login") {
    next("/dashboard");
    return;
  }

  if (firebase.auth.currentUser != null && to.path === "/sign-up") {
    next("/dashboard");
    return;
  }

  next();
});

export default router;
